import { TextField } from "@mui/material";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { useState } from "react";
import { useCookies } from "react-cookie";
import { isExternalUser } from "../utils/auth";
const Login = () => {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [, setCookie] = useCookies(["userType"]);
  const { tenantType } = window.localStorage;
  const isExternal = isExternalUser();
  const extractEmailInfo = (email) => {
    const emailInfo = email.match(/^(.+)@(usbank|fmr|amazon)\.(.+)/);
    return emailInfo;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // extract email domain for partner idpId
    const emailInfo = extractEmailInfo(e.target.email.value);

    if (emailInfo !== null) {
      if (emailInfo[2] === "fmr" || emailInfo[2] === "usbank" || emailInfo[2] === "amazon") {
        window.location.assign(
          `${
            process.env.NODE_ENV === "development"
              ? "http://localhost:8085"
              : process.env.NODE_ENV === "production"
              ? window.location.origin
              : window.location.origin
          }/api/auth/sso/login?userType=${emailInfo[2]}&tenantType=${tenantType}`
        );
      }
    }
  };

  const handleEmailChange = (e) => {
    const emailInfo = extractEmailInfo(e.target.value);

    if (emailInfo === null) {
      setEmailError(true);
    } else {
      setEmailError(false);
    }

    setEmail(e.target.value);
  };

  return (
    <Container sx={{ mt: 2 }}>
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
            error={emailError}
            value={email}
            onChange={handleEmailChange}
            helperText={emailError ? "Invalid Email Address." : ""} />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Login
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default Login;
